import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeaders = () => {
  const jwt_token = localStorage.getItem("jwt_token");
  return { Authorization: `Bearer ${jwt_token}` };
};

export const getVisaTypes = async () => {
  const res = await axios.get(`${API_URL}/visa/types`);
  return res.data;
};

export const getNationalities = async () => {
  const res = await axios.get(`${API_URL}/nationalities`, {
    headers: getAuthHeaders(),
  });
  return res.data;
};

export const getGenders = async () => {
  const res = await axios.get(`${API_URL}/genders`, {
    headers: getAuthHeaders(),
  });
  return res.data;
};

export const getPaymentMethods = async () => {
  const res = await axios.get(`${API_URL}/visa/payment-methods`);
  return res.data;
};

export const createVisaApplication = async (payload) => {
  const res = await axios.post(`${API_URL}/visa/create`, payload, {
    headers: getAuthHeaders(),
  });
  return res.data;
};

export const saveApplicantInfo = async (applicationId, payload) => {
  const res = await axios.post(
    `${API_URL}/visa/applicant/${applicationId}`,
    payload,
    { headers: getAuthHeaders() }
  );
  return res.data;
};

export const saveTravelInfo = async (applicationId, payload) => {
    const res = await axios.put(
        `${API_URL}/visa/travel/${applicationId}`,
        payload,
        { headers: getAuthHeaders() }
    );
    return res.data;
}

export const uploadVisaDocuments = async (applicationId, formData) => {
    const res = await axios.post(
        `${API_URL}/visa/upload-doc/${applicationId}`,
        formData,
        {
            headers: {
                ...getAuthHeaders(),
                "Content-Type": "multipart/form-data",
            },
        }
    );
    return res.data;
}

export const acceptVisaTerms = async (applicationId) => {
    const res = await axios.put(
        `${API_URL}/visa/terms/${applicationId}`,
        {},
        { headers: getAuthHeaders() }
    );
    return res.data;
}

export const getPreviousApplications = async () => {
    const res = await axios.get(`${API_URL}/visa/all-status`, {
        headers: getAuthHeaders(),
    });
    return res.data;
}

export const getVisaPolicyMeta = async () => {
  const res = await axios.get(`${API_URL}/visa/policy-meta`);
  return res.data;
};

export const calculateVisaFee = async (body) => {
  const res = await axios.post(`${API_URL}/visa/calculate-fee`, body);
  return res.data;
};


